import React, { useContext } from "react";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Avatar from "@mui/joy/Avatar";
import Sheet from "@mui/joy/Sheet";
import Chip from "@mui/joy/Chip";
import Button from "@mui/joy/Button";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import { ChatContext } from "../mensajecontext";

export default function Headerchat({
  foto_amigo,
  nombre_amigo,
  edad,
  actividades,
}) {
  const { aparecerDisenoChat } = useContext(ChatContext);
  let almacenamientoURL = process.env.REACT_APP_DOSPACES;

  /* Calcula Edad */
  const calcularEdad = (fechaNacimiento) => {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    const edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      return edad - 1;
    }
    return edad;
  };
  /* Calcula Edad*/

  let headerMobile = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
        }}
      >
        <Box
          sx={{
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            textAlign: "center",
            gap: 1,
            margin: 5,
            marginTop: 3,
          }}
        >
          <Button
            onClick={aparecerDisenoChat}
            startDecorator={<KeyboardReturnIcon />}
            variant="plain"
            color="neutral"
            size="sm"
          >
            Volver
          </Button>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <Avatar
              size="lg"
              src={`${almacenamientoURL}/uploads/${foto_amigo}`}
            />
          </Box>

          <Typography level="title-lg">
            {nombre_amigo
              ? `${nombre_amigo}, ${calcularEdad(edad)} años`
              : null}
          </Typography>
          <Box
            sx={{
              display: "grid",
              gap: 1,
              placeItems: "center",
            }}
          >
            {actividades
              ? actividades.map((x, index) => {
                  return (
                    <Chip size="sm" key={index}>
                      {x}
                    </Chip>
                  );
                })
              : null}
          </Box>
        </Box>
      </Box>
    );
  };

  let headerDesktop = () => {
    return (
      <Box>
        {" "}
        <Box sx={{ display: "flex", margin: 5, gap: 2 }}>
          <Avatar
            size="lg"
            src={`${almacenamientoURL}/uploads/${foto_amigo}`}
          />
          <Box sx={{ display: { md: "flex-grid", xs: "" }, gap: 0 }}>
            <Typography level="title-lg">
              {nombre_amigo
                ? `${nombre_amigo}, ${calcularEdad(edad)} años`
                : null}
            </Typography>
            <Box
              sx={{
                display: { md: "flex", xs: "grid" },
                gap: 1,
                marginTop: { xs: 0.5 },
              }}
            >
              {actividades
                ? actividades.map((x, index) => {
                    return (
                      <Chip size="sm" key={index}>
                        {x}
                      </Chip>
                    );
                  })
                : null}
            </Box>
          </Box>
          <Box sx={{ marginLeft: "auto" }}>
            {false ? (
              <Button variant="outlined" color="neutral">
                Ver Perfil
              </Button>
            ) : null}
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <Box>
      <Box
        sx={{
          display: { xs: "grid", md: "none", lg: "none" },
        }}
      >
        {headerMobile()}
      </Box>

      <Box sx={{ display: { xs: "none", md: "grid", lg: "grid" } }}>
        {headerDesktop()}
      </Box>
    </Box>
  );
}
